import {Routes, RouterModule} from '@angular/router';
import {EventListComponent} from './screens/event-list/event-list.component';
import {EventDetailComponent} from './screens/event-detail/event-detail.component';
import {CheckoutComponent} from './screens/checkout/checkout.component';
import {PaymentComponent} from './screens/payment/payment.component';
import {SwishConfirmationComponent} from './screens/confirmation/swish-confirmation/swish-confirmation.component';
import {GeneralConfirmationComponent} from './screens/confirmation/general-confirmation/general-confirmation.component';
import {PaysonConfirmationComponent} from './screens/confirmation/payson-confirmation/payson-confirmation.component';
import {GeneralErrorComponent} from './screens/exception/general-error/general-error.component';
import {SwishExceptionComponent} from './screens/exception/swish-exception/swish-exception.component';
import {CustomerLayoutComponent} from './layout/customer-layout/customer-layout.component';
import {HomeComponent} from './screens/home/home.component';
import {AboutComponent} from './screens/about/about.component';
import {DancestoreLayoutComponent} from './layout/dancestore-layout/dancestore-layout.component';

const appRoutes: Routes = [
  {
    path: '',
    component: DancestoreLayoutComponent,
    children: [
      {path: '', component: HomeComponent, pathMatch: 'full'},
      {path: 'about', component: AboutComponent}
      ]
  },
  {
    path: '',
    component: CustomerLayoutComponent,
    children: [
      {path: ':username/event-list', component: EventListComponent},
      {path: ':username/event-detail', component: EventDetailComponent},
      {path: ':username/checkout', component: CheckoutComponent},
      {path: ':username/payment', component: PaymentComponent},
      {path: 'swish/confirmation', component: SwishConfirmationComponent},
      {path: 'payson/confirmation', component: PaysonConfirmationComponent},
      {path: 'confirmation', component: GeneralConfirmationComponent},
      {path: 'error', component: GeneralErrorComponent},
      {path: 'swish/payment-fail', component: SwishExceptionComponent}
    ]
  },
  {path: '**', redirectTo: ''}
];
export const routing = RouterModule.forRoot(appRoutes, {useHash: true});


